if (!window.Maximize.loadedScript.includes('sticky-atc.js')) {
  window.Maximize.loadedScript.push('sticky-atc.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.store('stickyATC', {
        isOpen: false,
        isFooterShow: false,
        isProductInfoOutOfView: false,
        isOpenDetailOnMobile: false,
        scrollY: 0,

        handleInit(sectionId) {
          this.scrollY = window.scrollY;

          const section = document.querySelector(`.section--${sectionId}`);
          const footerElement = document.getElementById('x-footer');
          const bundleSections = document.querySelectorAll('.x-bundle-section');

          const getTriggerElement = () => {
            return (
              section?.querySelector('.product-info__buy-buttons-wrapper') ||
              section?.querySelector('.product-form__btn-add-to-cart') ||
              section?.querySelector('.product-template__content-wrapper')
            );
          };

          const updateStickyState = () => {
            const triggerElement = getTriggerElement();

            if (!triggerElement) {
              this.isOpen = false;
              this.isProductInfoOutOfView = false;
              return;
            }

            const rect = triggerElement.getBoundingClientRect();

            let isAnyBundleVisible = false;
            bundleSections.forEach((el) => {
              const bundleRect = el.getBoundingClientRect();
              if (
                window.innerWidth < 1023 &&
                bundleRect.top < window.innerHeight &&
                bundleRect.bottom > 0
              ) {
                isAnyBundleVisible = true;
              }
            });

            let footerVisible = false;
            if (footerElement) {
              const footerRect = footerElement.getBoundingClientRect();
              footerVisible = footerRect.top < window.innerHeight && footerRect.bottom > 0;
            }

            this.isFooterShow = footerVisible;

            /*
              Déclenchement :
              - quand le bouton panier principal est passé au-dessus de l'écran
              - on garde une petite marge pour éviter les clignotements
            */
            this.isProductInfoOutOfView = rect.top < window.innerHeight * 0.45;

            this.isOpen =
              this.isProductInfoOutOfView &&
              !this.isFooterShow &&
              !isAnyBundleVisible;
          };

          window.addEventListener('scroll', updateStickyState, { passive: true });
          window.addEventListener('resize', updateStickyState);

          setTimeout(updateStickyState, 100);
          setTimeout(updateStickyState, 500);
          updateStickyState();
        }
      });

      Alpine.data('xStickyATC', (stickyATCContainerEl, sectionId) => ({
        isOpenDetailOnMobile: false,
        isFirstLoading: true,
        isMobile: window.innerWidth < MIN_DEVICE_WIDTH.desktop,
        availableOptions: [],
        variantOptionsEle: [],
        options: [],
        optionsSelectedValues: [],

        init() {
          this.optionElements = this.$el.querySelectorAll(
            `#StickyAddToCart__Variant__${sectionId} .variant-option`
          );

          this.optionsSelectedValues = this.updateOptionSelectedValues();

          const isMobile = window.matchMedia(`(max-width: ${MIN_DEVICE_WIDTH.desktop - 1}px)`);

          const handleMediaChange = (e) => {
            if (e.matches) {
              this.isMobile = true;
              if (!this.isFirstLoading) {
                Alpine.store('stickyATC').isOpenDetailOnMobile = true;
              }
            } else {
              this.isMobile = false;
              Alpine.store('stickyATC').isOpenDetailOnMobile = false;
            }
          };

          handleMediaChange(isMobile);
          isMobile.addEventListener('change', handleMediaChange);

          this.isFirstLoading = false;
        },

        selectOptionSticky(event) {
          const targetOption = event.currentTarget;
          const position = targetOption.dataset.optionPosition;

          this.optionsSelectedValues[Number(position) - 1] = targetOption.dataset.optionValueId;

          document.dispatchEvent(
            new CustomEvent(`${STICKY_ATC_EVENT.optionChange}-${sectionId}`, {
              detail: {
                optionsSelectedValues: this.optionsSelectedValues
              }
            })
          );
        },

        updateOptionSelectedValues() {
          const newOptionsSelectedValues = [];

          this.optionElements.forEach((optionEle) => {
            const optionPosition = optionEle.dataset.optionPosition;
            const idx = Number(optionPosition) - 1;

            if (optionEle.classList.contains('selected')) {
              newOptionsSelectedValues[idx] = optionEle.dataset.optionValueId;
            }
          });

          return newOptionsSelectedValues;
        }
      }));
    });
  });
}